import { useEffect, useState } from 'react'
import { breakpoints } from 'globalStyles'

const useDetectTablet = () => {
  // Tablet: width >= sm and < lg
  const [mQuery, setMQuery] = useState({
    matches: globalThis.matchMedia(breakpoints.tablet).matches,
  })

  useEffect(() => {
    const mediaQueryList = globalThis.matchMedia(breakpoints.tablet)
    const handler = (e) => setMQuery(e)
    mediaQueryList.addEventListener('change', handler)
    return () => mediaQueryList.removeEventListener('change', handler)
  }, [])

  return mQuery.matches
}

export default useDetectTablet
